import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

interface Props {
    contactId: number;
    contactName: string;
    numUnread: number;
}

export default function NewRecentItemCheckbox({ contactId, contactName, numUnread }: Props) {
    return (
        <IconButton
            aria-label="Toggle select"
            // aria-pressed={isSelected}
            // onClick={handleSelect}
            size="large"
            disabled
        >
            <Badge
                badgeContent={numUnread}
                overlap="circular"
                color="secondary"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <Avatar variant="rounded">
                    {/* {isSelected ? <CheckIcon /> : contactName.slice(0, 1)} */}
                    {contactName.slice(0, 1)}
                </Avatar>
            </Badge>
        </IconButton>
    );
}
